export const strings = {
    "Addrole" : "role",
    "recordSubmitted" : "Record submitted",
    "updatedSuccessfully":"Updated Successfully"
}